// Epicor inventory API client (stock levels, warehouses, history).
// Read-only; sync runs are enqueued through the Epicor jobs API
// (createEpicorJob with stage: 'inventory').
import syncApi from './syncApi';

export const getInventorySummary = () =>
  syncApi.get('/inventory/summary').then((r) => r.data);

export const listInventoryWarehouses = (params) =>
  syncApi.get('/inventory/warehouses', { params }).then((r) => r.data);

export const setWarehouseEnabled = (company, warehouseCode, enabled) =>
  syncApi
    .patch(`/inventory/warehouses/${company}/${encodeURIComponent(warehouseCode)}`, { enabled })
    .then((r) => r.data);

// Manual detail fields (display_name, phone, operating_hours, address_*).
// Only keys present in `fields` are updated; null/'' clears a field.
export const updateWarehouseDetails = (company, warehouseCode, fields) =>
  syncApi
    .patch(`/inventory/warehouses/${company}/${encodeURIComponent(warehouseCode)}`, fields)
    .then((r) => r.data);

export const listStockLevels = (params) =>
  syncApi.get('/inventory/stock', { params }).then((r) => r.data);

export const getStockDetail = (company, partNum, params) =>
  syncApi
    .get(`/inventory/stock/${company}/${encodeURIComponent(partNum)}`, { params })
    .then((r) => r.data);

export const getAvailability = (skus, params = {}) =>
  syncApi
    .get('/inventory/availability', { params: { skus: skus.join(','), ...params } })
    .then((r) => r.data);
